import {h, Component} from 'preact';
import * as Cookies from 'es-cookie';
import {IBookingForm, IConfiguration} from "../typings";
import "./../css/components/speech-bubble.css"

export default class SpeechBubble extends Component<ISpeechBubbleProps, ISpeechBubbleState> {
    static SPEECH_BUBBLE_COOKIE = "speechbubble";

    constructor(props: ISpeechBubbleProps,context) {
        super(props);
        this.state = {
            visible: !(Cookies.get(SpeechBubble.SPEECH_BUBBLE_COOKIE) != undefined && Cookies.get(SpeechBubble.SPEECH_BUBBLE_COOKIE) === 'true'),
        };
    }

    static suppressSpeechBubbleWithCookie = () => Cookies.set(SpeechBubble.SPEECH_BUBBLE_COOKIE, 'true', {expires: new Date(Date.now() + 864e5)});

    closeBubble = (e) => {
        e.stopPropagation();
        SpeechBubble.suppressSpeechBubbleWithCookie()
        this.setState({visible: false});
    }

    openChat = (e) => {
        this.closeBubble(e);
        this.props.onClick();
    }

    render({onClick, conf}: ISpeechBubbleProps, {}) {

        if (!this.state.visible || !this.props.conf.showBubble) return;

        return (
            <div className="speechbubble" id="speechbubble" onClick={this.openChat}>
                <div id="speechbubble-icon" className="wrap-icon" onClick={this.closeBubble}>
                    <svg className="jovin-icon icon--close icon--color-black">
                        <g id="XXLarge-1920" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Menu_click" transform="translate(-1818.000000, -56.000000)" stroke="currentColor">
                                <rect x="0" y="0" width="1920" height="1080"></rect>
                                <g id="16/plus"
                                   transform="translate(1824.000000, 62.000000) rotate(-45.000000) translate(-1824.000000, -62.000000) translate(1816.000000, 54.000000)">
                                    <path
                                        d="M8.5,7.5 L16,7.5 L16,8.5 L8.5,8.5 L8.5,16 L7.5,16 L7.5,8.5 L0,8.5 L0,7.5 L7.5,7.5 L7.5,0 L8.5,0 L8.5,7.5 Z"
                                        id="Combined-Shape"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <b>{this.props.conf.title}</b>
                <span>{this.props.conf.bubbleMessage}</span>
            </div>

        );
    }
}

interface ISpeechBubbleProps {
    onClick: any,
    conf: IConfiguration
}

interface ISpeechBubbleState {
    visible: boolean,
}
